module.exports = __webpack_public_path__ + "resources/img/main_banner10.c628ad0f99754cb725d6886a442d8da4.png";